import _ from 'lodash'

/**
 * Compute the collection variable name for a given variable name, via appropriate pluralization.
 * @param {string} variableName - The variable name to compute the collection variable name for.
 * @returns {string} The collection variable name.
 */
export function computeCollectionVariableName (variableName) {
  let append = ''
  if (_.endsWith(variableName, 'y') && !_.endsWith(variableName, 'ay')) {
    return variableName.substr(0, variableName.length - 1) + 'ies'
  } else if (_.endsWith(variableName, 's') || _.endsWith(variableName, 'x')) {
    append = 'es'
  } else {
    append = 's'
  }
  return variableName + append
}
